import Vue from "vue";
import { vuexfireMutations } from "vuexfire";
import Vuex from "vuex";
import { db, storage } from "@/config/firebaseInit";

Vue.use(Vuex);
import createPersistedState from "vuex-persistedstate";

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    isMobile: false,
    kiosk: null,
    client: null,
    our_community: null,
    coming_soon: null,
    build_homes: null,
    newHomes: null,
    legacyHomes: null,
    calendar: null,
    generic_images: null,
    new_homes_page: null,
    legacy_homes_page: null,
  },

  getters: {
    getKiosk: (state) => {
      return state.kiosk;
    },
  },
  mutations: {
    ...vuexfireMutations,
    setKiosk(state, kiosk) {
      state.kiosk = Object.assign({}, kiosk);
      state.kiosk.id = kiosk.id;
    },
    setClient(state, client) {
      state.client = client;
    },
    setOurCommunity(state, our_community) {
      state.our_community = our_community;
    },
    setComingSoon(state, coming_soon) {
      state.coming_soon = coming_soon;
    },
    setBuildHomes(state, build_homes) {
      state.build_homes = build_homes;
    },
    setNewHomes(state, new_homes) {
      state.newHomes = new_homes;
    },
    setLegacyHomes(state, new_homes) {
      state.legacyHomes = new_homes;
    },
    setIsMobile(state, isMobile) {
      state.isMobile = isMobile;
    },
    setNewHomesPage(state, page) {
      state.new_homes_page = page;
    },
    setLegacyHomesPage(state, page) {
      state.legacy_homes_page = page;
    },
    setCalendar(state, calendar) {
      state.calendar = calendar;
    },
    setGenericImages(state, images) {
      state.generic_images = images;
    },
  },
  actions: {
    async updateClient(context) {
      await db
        .collection("client")
        .doc(context.state.client.id)
        .onSnapshot((doc) => {
          if (doc.exists) {
            let client_data = doc.data();
            client_data.id = doc.id;
            context.commit("setClient", client_data);
            context.dispatch("getListings");
            context.dispatch("updateOurCommunity");
            context.dispatch("updateComingSoon");
            context.dispatch("updateBuildHomes");
            context.dispatch("updateNewHomesPage");
            context.dispatch("setLegacyHomesPage");
            context.dispatch("updateCalendar");
            context.dispatch("updateGenericImages");
          }
          return true;
        });
    },
    resetHomes(context) {
      context.commit("setNewHomes", null);
      context.commit("setLegacyHomes", null);
    },
    async getListings(context) {
      await db
        .collection("listings")
        .doc(context.state.client.api_name)
        .onSnapshot((doc) => {
          if (doc.exists) {
            let community = doc.data();
            let listings = community.listings;
            let new_homes = listings.filter((listing) => {
              return listing.new_home;
            });
            let legacy_homes = listings.filter((listing) => {
              return !listing.new_home;
            });
            context.dispatch("resetHomes");
            context.commit("setNewHomes", new_homes);
            context.commit("setLegacyHomes", legacy_homes);
            if (context.state.client.shared_listings) {
              context.dispatch("getAdditionalListings");
            }
          } else {
            context.commit("setNewHomes", null);
            context.commit("setLegacyHomes", null);
          }
        });
    },
    async getAdditionalListings(context) {
      let listingsPromise = await context.state.client.shared_listings.map(
        (community) => {
          return db
            .collection(`listings`)
            .doc(community)
            .get()
            .then((doc) => {
              if (doc.exists) {
                let listings = doc.data().listings;
                let new_new_homes = listings.filter((listing) => {
                  return listing.new_home;
                });
                let new_legacy_homes = listings.filter((listing) => {
                  return !listing.new_home;
                });
                let new_homes = context.state.newHomes.concat(new_new_homes);
                let legacy_homes = context.state.legacyHomes.concat(
                  new_legacy_homes
                );
                context.commit("setNewHomes", new_homes);
                context.commit("setLegacyHomes", legacy_homes);
              }
            });
        }
      );
    },
    async updateOurCommunity(context) {
      db.collection("client")
        .doc(context.state.client.id)
        .collection("pages")
        .doc("our_community")
        .onSnapshot((doc) => {
          context.commit("setOurCommunity", doc.data());
        });
    },
    async updateComingSoon(context) {
      db.collection("client")
        .doc(context.state.client.id)
        .collection("pages")
        .doc("coming_soon")
        .onSnapshot((doc) => {
          context.commit("setComingSoon", doc.data());
        });
    },
    async updateBuildHomes(context) {
      db.collection("client")
        .doc(context.state.client.id)
        .collection("pages")
        .doc("build_homes")
        .onSnapshot((doc) => {
          context.commit("setBuildHomes", doc.data());
        });
    },
    async updateNewHomesPage(context) {
      db.collection("client")
        .doc(context.state.client.id)
        .collection("pages")
        .doc("new_homes")
        .onSnapshot((doc) => {
          context.commit("setNewHomesPage", doc.data());
        });
    },
    async setLegacyHomesPage(context) {
      db.collection("client")
        .doc(context.state.client.id)
        .collection("pages")
        .doc("legacy_homes")
        .onSnapshot((doc) => {
          context.commit("setLegacyHomesPage", doc.data());
        });
    },
    async updateCalendar(context) {
      db.collection("client")
        .doc(context.state.client.id)
        .collection("pages")
        .doc("calendar")
        .onSnapshot((doc) => {
          context.commit("setCalendar", doc.data());
        });
    },
    async updateGenericImages(context) {
      db.collection("image")
        .doc("generic")
        .onSnapshot((doc) => {
          context.commit("setGenericImages", doc.data());
        });
    },
  },
});
